import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import AdminLogin from '@/pages/AdminLogin';
import ForgotPassword from '@/pages/ForgotPassword';
import CompleteProfile from '@/pages/CompleteProfile';
import AdminDashboard from '@/pages/AdminDashboard';
import FamilyList from '@/pages/FamilyList';
import AddFamily from '@/pages/AddFamily';
import EditFamily from '@/pages/EditFamily';
import FamilyDetail from '@/pages/FamilyDetail';
import ImportFamilies from '@/pages/ImportFamilies';
import Inventory from '@/pages/Inventory';
import Reports from '@/pages/Reports';
import FamilyPortal from '@/pages/FamilyPortal';
import Settings from '@/pages/Settings';
import UserManagement from '@/pages/UserManagement';
import SchedulingInvitations from '@/pages/SchedulingInvitations';
import ScheduledDeliveries from '@/pages/ScheduledDeliveries';
import PendingSchedules from '@/pages/PendingSchedules';
import Announcements from '@/pages/Announcements';
import EditFamilyProfile from '@/pages/EditFamilyProfile';
import EmailLogs from '@/pages/EmailLogs';
import NewFamilies from '@/pages/NewFamilies';
import PendingScheduleInvitation from '@/pages/PendingScheduleInvitation';
import BulkInvitation from '@/pages/BulkInvitation';
import PublicRegister from '@/pages/PublicRegister';
import ProtectedRoute from '@/components/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/register" element={<PublicRegister />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/complete-profile" element={
            <ProtectedRoute roles={['family']}>
              <CompleteProfile />
            </ProtectedRoute>
          } />
          <Route path="/edit-family-profile" element={
            <ProtectedRoute roles={['family']}>
              <EditFamilyProfile />
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          <Route path="/dashboard" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer']}>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/families" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer']}>
              <FamilyList />
            </ProtectedRoute>
          } />
          
          <Route path="/new-families" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <NewFamilies />
            </ProtectedRoute>
          } />
          
          <Route path="/pending-schedule-invitation" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <PendingScheduleInvitation />
            </ProtectedRoute>
          } />
          
          <Route path="/bulk-invitation" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <BulkInvitation />
            </ProtectedRoute>
          } />
          
          <Route path="/families/add" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer']}>
              <AddFamily />
            </ProtectedRoute>
          } />
          
          <Route path="/families/import" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <ImportFamilies />
            </ProtectedRoute>
          } />
          
          <Route path="/families/edit/:id" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <EditFamily />
            </ProtectedRoute>
          } />
          
          <Route path="/families/:id" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer']}>
              <FamilyDetail />
            </ProtectedRoute>
          } />
          
          <Route path="/scheduling-invitations" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <SchedulingInvitations />
            </ProtectedRoute>
          } />
          
          <Route path="/scheduled-deliveries" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer']}>
              <ScheduledDeliveries />
            </ProtectedRoute>
          } />
          
          <Route path="/pending-schedules" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer']}>
              <PendingSchedules />
            </ProtectedRoute>
          } />
          
          <Route path="/inventory" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer']}>
              <Inventory />
            </ProtectedRoute>
          } />
          
          <Route path="/announcements" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <Announcements />
            </ProtectedRoute>
          } />
          
          <Route path="/reports" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <Reports />
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute roles={['admin', 'staff', 'volunteer', 'family']}>
              <Settings />
            </ProtectedRoute>
          } />
          
          <Route path="/users" element={
            <ProtectedRoute roles={['admin']}>
              <UserManagement />
            </ProtectedRoute>
          } />
          
          <Route path="/email-logs" element={
            <ProtectedRoute roles={['admin', 'staff']}>
              <EmailLogs />
            </ProtectedRoute>
          } />
          
          <Route path="/family-portal" element={
            <ProtectedRoute roles={['family']}>
              <FamilyPortal />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;